export default {
  apiKey: 'AIzaSyDWqxQFFhnR3qZcy46xKTuiGeV3dRg1g4w',
  projectId: 'giazo-e594b',
  storageBucket: 'gs://giazo-e594b.appspot.com',
};



// WEBPACK FOOTER //
// ./src/plugins/firebase.config.js